import React,{lazy,Suspense} from "react";
import { BrowserRouter, Route, Switch, Redirect} from "react-router-dom";
import CssBaseline from '@material-ui/core/CssBaseline';
import { Helmet } from "react-helmet";
// import Auth from "./Authenticate";
import { BUILD_TYPE, REDIRECT_301 } from "./Constants";
import AppLayout from './components/AppLayout';
import TAWebLayout from './components/AgentWebsite/Layout';
import NotFound from './components/Commons/404';
import Box  from "@material-ui/core/Box";
import CircularProgress  from "@material-ui/core/CircularProgress";
import AgentWebAbout from './components/AgentWebsite/Contact_About';
import HandleShareBookingLinkRedirection from "./components/AgentWebsite/Flights/shareBookingLink/handleShareBookingLinkRedirection";
import RedirectionLogin from "./components/redirectionLogin";
const News = React.lazy(() => import('./components/AgentWebsite/news'));
const TandC = React.lazy(() => import('./components/AgentWebsite/T&C'));
const Services = React.lazy(() => import('./components/AgentWebsite/Services'));
const NewsDetail = React.lazy(() => import('./components/AgentWebsite/news/NewsDetail'));
const AdditionalPages = React.lazy(() => import('./components/AgentWebsite/AdditionalPages'));
const ResellerListingDetail = React.lazy(() => import('./components/AgentWebsite/ResellerListing'));
const DestinationGuides = React.lazy(() => import('./components/AgentWebsite/DestinationGuides'));
const HotelsSearchForm = React.lazy(() => import("./components/AgentWebsite/CategorySearch/components/HotelsSearchForm"));
const DirectPay = React.lazy(() => import("./components/DirectPay"));
const ProductDetail = React.lazy(() => import("./components/AgentWebsite/ProductDetail"));
const AllProductList = React.lazy(() => import("./components/AgentWebsite/AllProductList"));
const AgentWebContact = React.lazy(() => import("./components/AgentWebsite/ContactUs"));
const DestinationDetails = React.lazy(() => import("./components/AgentWebsite/DestinationDetails"));
const CollectPayment = React.lazy(() => import("./components/AgentWebsite/CollectPayment"));
const PassengerDetail = React.lazy(() => import("./components/AgentWebsite/PassengerDetail"));
const CovidGuidelines = React.lazy(() => import("./components/AgentWebsite/covid"));
const PostCovid = React.lazy(() => import("./components/AgentWebsite/covid/PostCovidPlanner"));
const VirtualTours = React.lazy(() => import("./components/AgentWebsite/VirtualTours"));
const VirtualToursDetail = React.lazy(() => import("./components/AgentWebsite/VirtualToursDetail"));
const LinkPayment = React.lazy(() => import("./components/AgentWebsite/linkPayment"));
const VaccineSlots = React.lazy(() => import("./components/AgentWebsite/covid/CovidVaccineSlots"));
const VaccineDates = React.lazy(() => import("./components/AgentWebsite/covid/CovidVaccineSlots/availableDates"));
const CollectFeedback = React.lazy(() => import("./components/AgentWebsite/collectFeedback"));
const Flights = React.lazy(() => import("./components/AgentWebsite/Flights"));
const FlightsSearchResults = React.lazy(() => import("./components/AgentWebsite/Flights/searchResults"));
const FlightsSearchTravellers = React.lazy(() => import("./components/AgentWebsite/Flights/travellerDetails"));
const FlightsPayment = React.lazy(() => import("./components/AgentWebsite/Flights/bookingPayment/paymentReview"));
const FlightsBooking = React.lazy(() => import("./components/AgentWebsite/Flights/bookingPayment/booking"));
const Bookings = React.lazy(() => import("./components/AgentWebsite/Bookings"));
const BookingDetail = React.lazy(() => import("./components/AgentWebsite/Bookings/bookingDetail"));
const ShareBookingLink = React.lazy(() => import("./components/AgentWebsite/Flights/shareBookingLink"));
const GalleryView = React.lazy(() => import("./components/AgentWebsite/gallery/components/viewAll"));
const AllDestinationList = React.lazy(() => import("./components/AgentWebsite/AllDestinationList"));
const RemittanceDocUpload = lazy(() =>import("./components/Remittance"));
const Remittance = lazy(() =>import("./components/AgentWebsite/Remittance"));
const CreateRemittance = lazy(() =>import("./components/AgentWebsite/Remittance/CreateRemittancePage/createRemittance"));
const RemitTravellersForm = lazy(() =>import("./components/AgentWebsite/Remittance/TravellersFormPage"));



const newTitle =  BUILD_TYPE == 'STAGING' ? document.title : document.title

const Routes = () => (<BrowserRouter>
  <Helmet>
    <title>{newTitle}</title>
  </Helmet>
  <div>
    <CssBaseline />
    <Suspense  
     fallback={
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress/>
    </Box>
  }>
    <Switch>
      <Route
        exact
        path={["/en/remittance/:remit_id/upload", "/en/remittance/:remit_id/upload/:travelerId"]}
        component={() => (<AppLayout><RemittanceDocUpload /></AppLayout>)}
      />

      <Route
        exact
        path={["/:username/vaccine", "/vaccine"]}
        component={() => (<TAWebLayout><VaccineSlots /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/vaccine/dates", "/vaccine/dates"]}
        component={() => (<TAWebLayout><VaccineDates /></TAWebLayout>)}
      />

      <Route
        exact
        path={["/:username/pages/services", "/pages/services"]}
        component={() => (<TAWebLayout><Services /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/pages/terms-and-conditions", "/pages/terms-and-conditions"]}
        component={() => (<TAWebLayout><TandC /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/pages/:slug_url", "/pages/:slug_url"]}
        component={() => (<TAWebLayout><AdditionalPages /></TAWebLayout>)}
      />

      <Route
        exact
        path={["/:username/listings/:title", "/listings/:title"]}
        component={() => (<TAWebLayout><ProductDetail /></TAWebLayout>)}
      />

      <Route
        exact
        path={["/:username/packages/shared-quotes/:title", "/packages/shared-quotes/:title"]}
        component={() => (<TAWebLayout><ProductDetail isQuotesPage={true}/></TAWebLayout>)}
      />

      <Route
        exact
        path={
          ["/:username/resellerlisting/:title", "/resellerlisting/:title",
            "/:username/package/:title", "/package/:title",
            "/:username/customerquote/:title", "/customerquote/:title"]
        }
        component={() => (<TAWebLayout><ResellerListingDetail /></TAWebLayout>)}
      />

      <Route
        exact
        path={["/:username/passengerdetails/:bookingPaymentCode", "/passengerdetails/:bookingPaymentCode"]}
        component={() => (<TAWebLayout><PassengerDetail /></TAWebLayout>)}
      />

      <Route
        exact
        path={["/:username/about", "/about"]}
        component={() => (<TAWebLayout><AgentWebAbout /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/contact", "/contact"]}
        component={() => (<TAWebLayout><AgentWebContact /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/packages", "/packages"]}
        component={() => (<TAWebLayout><AllProductList /></TAWebLayout>)}
      />
       <Route
        exact
        path={["/:username/destinations", "/destinations"]}
        component={() => (<TAWebLayout><AllDestinationList /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/covid/planner", "/covid/planner", "/:username/covid/planner/:section", "/covid/planner/:section"]}
        component={() => <TAWebLayout><PostCovid /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/covid/:id", "/covid/:id"]}
        component={() => (<TAWebLayout><CovidGuidelines /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/en/my_bookings", "/en/my_bookings"]}
        component={() => (<TAWebLayout><Bookings/></TAWebLayout>)}
      />
       <Route
        exact
        path={["/:username/en/my_bookings/:code", "/en/my_bookings/:code"]}
        component={() => (<TAWebLayout><BookingDetail/></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/news", "/news"]}
        component={() => (<TAWebLayout><News /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/news/:id/:title", "/:username/news/:id", "/news/:id/:title", "/news/:id"]}
        component={() => (<TAWebLayout><NewsDetail /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/destination-guides", "/destination-guides"]}
        component={() => (<TAWebLayout><DestinationGuides /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/destination-guides/:id", "/destination-guides/:id"]}
        component={() => (<TAWebLayout><DestinationDetails /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/360tours", "/360tours"]}
        component={() => (<TAWebLayout><VirtualTours /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/360tours/:id", "/360tours/:id"]}
        component={() => (<TAWebLayout><VirtualToursDetail /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/pay", "/pay"]}
        component={() => (<TAWebLayout><CollectPayment /></TAWebLayout>)}
      />
      <Route
        exact
        path={["/:username/payment/:id", "/payment/:id"]}
        component={() => <TAWebLayout><LinkPayment /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/feedback/:id", "/feedback/:id"]}
        component={() => <TAWebLayout><CollectFeedback /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/flights", "/flights"]}
        component={() => <TAWebLayout><Flights /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/flights/search", "/flights/search"]}
        component={() => <TAWebLayout><FlightsSearchResults /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/flights/search/travellers", "/flights/search/travellers"]}
        component={() => <TAWebLayout><FlightsSearchTravellers /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/flights/search/travellers/pay", "/flights/search/travellers/pay"]}
        component={() => <TAWebLayout><FlightsPayment /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/flights/book", "/flights/book"]}
        component={() => <TAWebLayout><FlightsBooking /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/bl/:cuttlyId", "/bl/:cuttlyId"]}
        component={() => <HandleShareBookingLinkRedirection />}
      />
        <Route
        exact
        path={["/:username/flights/itinerary/", "/flights/itinerary/"]}
        component={() => <TAWebLayout><ShareBookingLink /></TAWebLayout>}
      />
      <Route
        exact
        path={["/:username/remittance", "/remittance"]}
        component={() => <TAWebLayout><Remittance /></TAWebLayout>} 
      />
      <Route
        exact
        path={["/:username/remittance/remit", "/remittance/remit"]}
        component={() => <TAWebLayout><CreateRemittance /></TAWebLayout>} 
      />
      <Route
        exact
        path={["/:username/remit/traveller/:travellerId", "/remit/traveller/:travellerId"]}
        component={() => <TAWebLayout><RemitTravellersForm /></TAWebLayout>} 
      />
      <Route
         path={["/:username/gallery_detail", "/gallery_detail"]}
        component={() => <TAWebLayout><GalleryView /></TAWebLayout>}/>


      <Route
        exact
         path={["/:username/directPay/:merchantOrderRequestId", "/directPay/:merchantOrderRequestId"]}
        component={() => (
        <TAWebLayout>
          <DirectPay />
        </TAWebLayout>)
        }
      />

      <Route exact
      path={['/:username/redirectionLogin','/redirectionLogin']}
      component={()=>(
        <TAWebLayout>
          <RedirectionLogin />
        </TAWebLayout>
      )}
      />

      <Route exact
      path={['/:username/hotelsearch','/hotelsearch']}
      component={()=>(
        <TAWebLayout>
          <HotelsSearchForm/>
        </TAWebLayout>
      )}
      />

         
      {/* Do not add new routes below this route */}
      
      <Route
        exact
        path={["/", "/#:elemId", "/:username", "/:username/#:elemId", "/package/:resellerListingId", "/customer_quote/:customerQuoteId"]}
        component={() => (<AppLayout></AppLayout>)}
      />

       <Route
        exact
        path={["/", "/#:elemId", "/:username", "/:username/#:elemId", "/package/:resellerListingId", "/customer_quote/:customerQuoteId"]}
        component={() => (<AppLayout></AppLayout>)}
      />

     

      {/* No matching route */}

      {REDIRECT_301 && <Route render={() => <Redirect to="/" />} />}
  
    </Switch>
    </Suspense>
  </div>
</BrowserRouter>
);

export default Routes;
